import React from 'react';
import Select, { components } from 'react-select';
import { Controller } from 'react-hook-form';
import classes from '../Form.module.scss';
import { pageScrollLock } from '../../../functions/functions';

const CustomValueContainer = ({ children, ...props }) => {
  const { ValueContainer, Placeholder } = components;

  return (
    <ValueContainer {...props}>
      <Placeholder {...props} isFocused={props.isFocused}>
        {props.selectProps.placeholder}
      </Placeholder>
      {React.Children.map(children, child => (child && child.type !== Placeholder ? child : null))}
    </ValueContainer>
  );
};

export default function FormSelect({
  control,
  name,
  register,
  onChange,
  addClass,
  errors,
  array,
  value,
  isDisabled,
  defaultValue,
  placeholder,
  errorLabel,
}) {
  const customOnChange = onChange ? { onChange } : null;

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <>
          <Select
            {...register}
            {...field}
            {...customOnChange}
            className={`${classes.customSelect} ${addClass} ${errors ? classes.customSelectErrors : ''}`}
            classNamePrefix={`${classes.regularSelect} ${errors}` ? classes.regularSelectErrors : ''}
            isClearable={false}
            isSearchable={false}
            options={array}
            value={value}
            isMulti={false}
            isDisabled={isDisabled}
            defaultValue={defaultValue}
            placeholder={placeholder}
            onMenuOpen={() => {
              document.querySelector(`#${name}SelectBox`).classList.add('opened-select-box');
              pageScrollLock(true);
            }}
            onMenuClose={() => {
              document.querySelector(`#${name}SelectBox`).classList.remove('opened-select-box');
              pageScrollLock(false);
            }}
            components={{
              ValueContainer: CustomValueContainer,
            }}
          />
          <div className={classes.customSelectOverlay} />
          <div className={classes.inputError}>{errors && errorLabel}</div>
        </>
      )}
    />
  );
}
